import { serviceHost } from "../../common/const";
import ServiceRequest from "../../utils/service-request";

export const registerUser = async (data) => {
  try {
    let response = await ServiceRequest(
      "post",
      "json",
      serviceHost + "/auth/createUser",
      data
    );
    return { response, err: null };
  } catch (err) {
    if (err) {
      return { response: null, err };
    }
  }
};

export const captcha = async (data) => {
  try {
    let response = await ServiceRequest(
      "get",
      "json",
      serviceHost + "/auth/captcha",
      data
    );
    return { response, err: null };
  } catch (err) {
    if (err) {
      return { response: null, err };
    }
  }
};

export const login = async (data) => {
  try {
    let response = await ServiceRequest(
      "post",
      "json",
      serviceHost + "/auth/login",
      data
    );
    return { response, err: null };
  } catch (err) {
    if (err) {
      return { response: null, err };
    }
  }
};

export const verifyToken = async (data) => {
  try {
    let response = await ServiceRequest(
      "get",
      "json",
      serviceHost + "/auth/user/verifyToken/" + data
    );
    return { response, err: null };
  } catch (err) {
    if (err) {
      return { response: null, err };
    }
  }
};

export const forgetPassword = async (data) => {
  try {
    let response = await ServiceRequest(
      "post",
      "json",
      serviceHost + "/auth/user/forgetPassword",
      data
    );
    return { response, err: null };
  } catch (err) {
    if (err) {
      return { response: null, err };
    }
  }
};

export const resetPasswordTokenVerify = async (data) => {
  try {
    let response = await ServiceRequest(
      "get",
      "json",
      serviceHost + "/auth/user/resetPasswordTokenVerify/" + data
    );
    return { response, err: null };
  } catch (err) {
    if (err) {
      return { response: null, err };
    }
  }
};

export const resetPassword = async (data) => {
  try {
    let response = await ServiceRequest(
      "post",
      "json",
      serviceHost + "/auth/user/resetPassword",
      data
    );
    return { response, err: null };
  } catch (err) {
    if (err) {
      return { response: null, err };
    }
  }
};

export const resetToken = async (data) => {
  try {
    let response = await ServiceRequest(
      "get",
      "json",
      serviceHost + "/auth/user/resetToken/" + data
    );
    return { response, err: null };
  } catch (err) {
    if (err) {
      return { response: null, err };
    }
  }
};
export const changePassword = async (data) => {
  try {
    let response = await ServiceRequest(
      "post",
      "json",
      serviceHost + "/auth/user/changePassword",
      data
    );
    return { response, err: null };
  } catch (err) {
    if (err) {
      return { response: null, err };
    }
  }
};

export const logout = () => {
  try {
    ServiceRequest("post", "json", serviceHost + "/auth/logout");
  } catch (err) {}
};
